import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Select } from "antd";
import * as results from "../../modules/results";
import styles from "../../styles/components/ExpectationsQuoteSelect.css";

function createItem(expectation) {
    return (
        <Select.Option
            key={expectation.id}
            className={styles.expectationsOption}
            value={`${expectation.id}`}
        >
            {expectation.theme}
        </Select.Option>
    );
}

function ExpectationsSelectMenu({
    expectations,
    selectExpectation,
    selectedExpectationId
}) {
    const onSelect = expectationId =>
        selectExpectation(parseInt(expectationId, 10));
    return (
        <Select
            id={"select-expectation"}
            className={styles.expectationsSelect}
            onSelect={onSelect}
            value={`${selectedExpectationId}`}
            dropdownMatchSelectWidth={false}
        >
            <Select.OptGroup className={styles.expectationsGroup}>
                {expectations.map(expectation => createItem(expectation))}
            </Select.OptGroup>
        </Select>
    );
}

export function ExpectationsQuoteSelect({
    expectations,
    selectExpectation,
    selectedExpectationId
}) {
    return (
        <div className={styles.quoteSelector}>
            <p className={styles.captionText}>Quotes about</p>
            <ExpectationsSelectMenu
                expectations={expectations}
                selectExpectation={selectExpectation}
                selectedExpectationId={selectedExpectationId}
            />
        </div>
    );
}

ExpectationsQuoteSelect.propTypes = {
    expectations: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            theme: PropTypes.string.isRequired
        })
    ),
    selectedExpectationId: PropTypes.number.isRequired
};

function mapDispatchToProps(dispatch, props) {
    return {
        selectExpectation: expectationId =>
            dispatch(results.selectExpectation(expectationId))
    };
}

export default connect(
    null,
    mapDispatchToProps
)(ExpectationsQuoteSelect);



// WEBPACK FOOTER //
// ./src/components/Results/ExpectationsQuotesSelect.js